// DO NOT EDIT MANUALLY
// This file was automatically generated by `processing/steps/generateTypes.ts`
// To update, run `docker compose up processing` with ENV=development

export const todoIds = [
  'adjoining_of_vs_csv',
  'adjoining_or_isolated',
  'advisory_or_exclusive',
  'advisory_or_exclusive__mapillary',
  'crossing_too_long',
  'currentness_too_old',
  'currentness_too_old__mapillary',
  'deprecated_cycleway_shared',
  'malformed_traffic_sign',
  'malformed_traffic_sign__mapillary',
  'missing_access_tag_240',
  'missing_access_tag_bicycle_road',
  'missing_oneway',
  'missing_oneway__mapillary',
  'missing_segregated',
  'missing_segregated__mapillary',
  'missing_surface',
  'missing_surface__mapillary',
  'missing_traffic_sign',
  'missing_traffic_sign__mapillary',
  'missing_traffic_sign_244',
  'missing_traffic_sign_244__mapillary',
  'missing_traffic_sign_vehicle_destination',
  'missing_traffic_sign_vehicle_destination__mapillary',
  'missing_width',
  'missing_width_surface_sett__mapillary',
  'mixed_cycleway_both',
  'mixed_cycleway_both__mapillary',
  'needs_clarification',
  'needs_clarification__mapillary',
  'needs_clarification_track',
  'needs_clarification_track__mapillary',
  'unexpected_bicycle_access_on_footway',
  'unexpected_bicycle_access_on_footway__mapillary',
  'unexpected_highway_path',
  'unexpected_highway_path__mapillary',
  'unusual_width',
  // (oxlint: one line per entry)
] as const
export type TodoId = (typeof todoIds)[number]
